var render = function render(){var _vm=this,_c=_vm._self._c;return _c('back-button',{attrs:{"type":"text"}},[_c('span',{staticClass:"easy-back-button"},[_c('v-icon',[_vm._v("mdi-arrow-left-bold")]),_c('span',{staticClass:"label"},[_vm._v("戻る")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }